<div *ngIf="agentMode" class="govuk-width-container">
  <button type="button" class="btn btn-primary" data-module="govuk-button" (click)="datastoreService?.agentRestart()">
    Agent Restart
  </button>
</div>

<div class="row breadcrumb-container">
  <div class="col-12">
    <div class="govuk-width-container">
      <govuk-ui-breadcrumb [items]="breadcrumbItems"></govuk-ui-breadcrumb>
    </div>
  </div>
</div>
<div class="govuk-width-container">
  <div class="row m-0">
    <div class="col-sm-12 p-0">
      <gb-ui-back-link (back)="routerGoBack()"></gb-ui-back-link>
    </div>
  </div>
</div>
<main id="main-content" tabindex="-1">
  <div class="row page-heading-container">
    <div class="col-12">
      <gb-ui-page-heading [titleText]="this.selectedDepartment?.extra?.booking_details_page_title">
        <ng-template #subContent>
          <p>Before proceeding with booking your ceremony we require information about you.</p>
        </ng-template>
      </gb-ui-page-heading>
    </div>
  </div>
  <div class="govuk-width-container">
    <div class="govuk-main-wrapper govuk-main-wrapper--l" id="main-content">
      <div class="govuk-grid-row">
        <div class="govuk-grid-column-full">
          <ng-container>
            <form [formGroup]="customerDetailsForm" *ngIf="showContactForm">
              <div class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    form.first_name.errors?.required === true && submitted
                }">

                <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse" for="first_name">
                  {{ 'COMMON.FIRST_NAME' | translate }}
                </label>
                
                <p *ngIf="submitted && form.first_name?.errors" id="event-name-error" class="govuk-error-message">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.IS_REQUIRED'
                  | translate : { value: 'COMMON.FIRST_NAME' | translate }
                  }}
                </p>
                <input maxlength="49" formControlName="first_name" class="govuk-input" id="first_name" name="eventName"
                  type="text" (change)="radioCopyChange()" [ngClass]="{
                    'govuk-input--error':
                      form.first_name.errors?.required === true && submitted
                  }" [disabled]="tokenValid" aria-required="true" />
              </div>

              <!-- <h2 class="mt-1 pb-4">{{'FORM.YOUR_TITLE' | translate}}</h2>
                        <div class="govuk-form-group">
                            <label tabindex="0" for="fn"> <span aria-hidden="true" class="form-field-required-marker">
                                    *</span> {{'COMMON.FIRST_NAME' | translate}}</label>
                            <input id="fn" type="text" class="form-control" formControlName="first_name" role="textbox">
                            <div *ngIf="submitted && form.first_name.errors" class="invalid-feedback">
                                <div *ngIf="form.first_name.errors?.required" role="alert" tabindex="0">
                                    {{ 'COMMON.IS_REQUIRED' | translate: {value: 'COMMON.FIRST_NAME' | translate } }}
                                </div>
                            </div>
                        </div> -->

              <div class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    form.last_name.errors?.required === true && submitted
                }">

                <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse" for="last_name">
                  {{ 'COMMON.LAST_NAME' | translate }}
                </label>

                <p *ngIf="submitted && form.last_name.errors" id="event-name-error" class="govuk-error-message">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.IS_REQUIRED'
                  | translate : { value: 'COMMON.LAST_NAME' | translate }
                  }}
                </p>
                <input maxlength="49" formControlName="last_name" class="govuk-input" id="last_name" name="eventName"
                  type="text" (change)="radioCopyChange()" [ngClass]="{
                    'govuk-input--error':
                      form.last_name.errors?.required === true && submitted
                  }" [disabled]="tokenValid" aria-required="true" />
              </div>

              <div class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    (form.email_address.errors?.required ||
                      form.email_address.errors?.pattern) &&
                    submitted
                }">

                <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse" for="email_address">
                  {{ 'COMMON.EMAIL_ADDRESS' | translate }}
                </label>


                <p *ngIf="submitted && form.email_address?.errors" id="event-name-error" class="govuk-error-message">
                  <!-- required -->
                  <ng-container *ngIf="form.email_address?.errors?.required">
                    <span class="govuk-visually-hidden">Error:</span>
                    {{
                    'COMMON.IS_REQUIRED'
                    | translate : { value: 'COMMON.EMAIL_ADDRESS' | translate }
                    }}
                  </ng-container>
                  <!-- pattern -->
                  <ng-container *ngIf="form.email_address?.errors?.pattern">
                    <span class="govuk-visually-hidden">Error:</span>
                    {{
                    'COMMON.INVALID'
                    | translate : { value: 'COMMON.EMAIL_ADDRESS' | translate }
                    }}
                  </ng-container>
                </p>

                <input formControlName="email_address" class="govuk-input" id="email_address" name="eventName"
                  (change)="radioCopyChange()" type="text" [ngClass]="{
                    'govuk-input--error':
                      form.email_address.errors?.required === true && submitted
                  }" [disabled]="tokenValid" aria-required="true" />

                <fieldset *ngIf="adminJourney" aria-describedby="email_address_consent">
                  <br />
                  <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                    <div class="govuk-checkboxes__item">
                      <input formControlName="email_address_consent" class="govuk-checkboxes__input"
                        id="email_address_consent_box" name="email_address_consent_box" type="checkbox"
                        aria-required="true" />

                      <label class=" govuk-checkboxes__label" for="email_address_consent_box">
                        {{ 'COMMON.ADMIN_EMAIL_HINT' | translate }}
                      </label>
                    </div>
                  </div>
                  <p class="govuk-error-message" *ngIf="submitted && form.email_address_consent.errors">
                    <span class="govuk-visually-hidden">Error:</span> As we are
                    going to be using email as the point of reminding customers
                    about their ceremony, we really need to ensure that this is
                    correct at the booking.
                  </p>
                </fieldset>
              </div>

              <div *ngIf="adminJourney">
                <div class="govuk-notification-banner" role="region" aria-labelledby="govuk-notification-banner-title"
                  data-module="govuk-notification-banner">
                  <div class="govuk-notification-banner__header">
                    <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                      ADMIN GUIDANCE: Email address required
                    </h2>
                  </div>
                  <div class="govuk-notification-banner__content">
                    <p aria-label="Notification message"
                      class="govuk-notification-banner__heading govuk-notification-banner__heading--inverse">
                      {{ 'COMMON.ADMIN_EMAIL_NOTIFICATION' | translate }}
                      <br /><br />
                      {{ 'COMMON.ADMIN_EMAIL_NOTIFICATION_TWO' | translate }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- Passwords -->
              <ng-container *ngIf="!adminJourney">
                <div class="govuk-form-group govuk-password-input" data-module="govuk-password-input" #password>

                  <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse" for="password-input">
                    {{ 'COMMON.PASSWORD' | translate }}
                  </label>

                  <div id="password-name-hint" class="govuk-hint">
                    {{ 'COMMON.PASSWORD_HINT' | translate }}
                  </div>
                  <div id="password-name-hint" class="govuk-hint">
                    {{ 'COMMON.PASSWORD_HINT_TWO' | translate }}
                  </div>
                  <p *ngIf="submitted && form.password?.errors" id="event-name-error" class="govuk-error-message">
                    <span *ngIf="form.password?.errors?.passwordInvalid" class="govuk-visually-hidden">Error:</span>
                    {{ 'COMMON.PASSWORD_PATTERN' | translate }}
                  </p>
                  <div class="govuk-input__wrapper govuk-password-input__wrapper">
                    <input class="govuk-input govuk-password-input__input govuk-js-password-input-input"
                      id="password-input" formControlName="password" name="password" type="password" spellcheck="false"
                      autocomplete="current-password" autocapitalize="none" />
                    <button type="button"
                      class="btn btn-outline-primary govuk-password-input__toggle govuk-js-password-input-toggle"
                      aria-controls="password-input" aria-label="Show password" hidden>
                      Show
                    </button>
                  </div>
                </div>
              </ng-container>

              <!-- Passwords end-->

              <div class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    (form.contact_number.errors?.required ||
                      form.contact_number.errors?.pattern ||
                      form.contact_number.errors?.minlength ||
                      form.contact_number.errors?.maxlength) &&
                    submitted
                }">

                <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse" for="contact_number">
                  {{ 'COMMON.CONTACT_NUMBER' | translate }}
                </label>

                <div id="event-name-hint" class="govuk-hint">
                  {{ 'COMMON.PHONE_HINT' | translate }}
                </div>
                <!--	<div id="event-name-hint" class="govuk-hint">
                  {{ 'COMMON.PHONE_HINT_TWO' | translate }}
                </div>-->
                <p *ngIf="submitted && form.contact_number?.errors" id="event-name-error" class="govuk-error-message">
                  <!-- required -->
                  <ng-container *ngIf="form.contact_number?.errors?.required">
                    <span class="govuk-visually-hidden">Error:</span>
                    {{
                    'COMMON.IS_REQUIRED'
                    | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                    }}
                  </ng-container>
                  <!-- pattern -->
                  <ng-container *ngIf="form.contact_number?.errors?.pattern">
                    <span class="govuk-visually-hidden">Error:</span>
                    {{
                    'COMMON.INVALID'
                    | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                    }}
                  </ng-container>
                  <!-- minlength -->
                  <ng-container *ngIf="form.contact_number?.errors?.minlength">
                    <span class="govuk-visually-hidden">Error:</span>
                    {{
                    'COMMON.INVALID'
                    | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                    }}
                  </ng-container>
                  <!-- maxlength -->
                  <ng-container *ngIf="form.contact_number?.errors?.maxlength">
                    <span class="govuk-visually-hidden">Error:</span>
                    {{
                    'COMMON.INVALID'
                    | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                    }}
                  </ng-container>
                </p>
                <input formControlName="contact_number" class="govuk-input" id="contact_number" name="eventName"
                  (change)="radioCopyChange()" (keypress)="keyPressNumberField($event)" type="text" maxlength="15"
                  [ngClass]="{
                    'govuk-input--error':
                      form.contact_number.errors?.required === true && submitted
                  }" aria-required="true" />

                <fieldset *ngIf="adminJourney" aria-describedby="contact_number_consent">
                  <br />
                  <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                    <div class="govuk-checkboxes__item">
                      <input formControlName="contact_number_consent" class="govuk-checkboxes__input"
                        id="contact_number_consent_box" name="contact_number_consent_box" type="checkbox"
                        aria-required="true" />

                      <label class=" govuk-checkboxes__label" for="contact_number_consent_box">
                        {{ 'COMMON.ADMIN_CONTACT_NUMBER_HINT' | translate }}
                      </label>
                    </div>
                  </div>
                  <p class="govuk-error-message" *ngIf="submitted && form.contact_number_consent.errors">
                    <span class="govuk-visually-hidden">Error:</span> As we are
                    going to be using the contact number as the point of reminding
                    customers about their ceremony, we really need to ensure that
                    this is correct at the booking.
                  </p>
                </fieldset>
              </div>

              <!-- <div class="govuk-radios" data-module="govuk-radios" role="radiogroup" aria-labelledby="copyDataLabel">
                <h3 id="copyDataLabel">
                  <span for="contact_number">
                    {{ 'COMMON.COPY_DETAILS' | translate }}
                  </span>
                </h3>
                <div class="govuk-radios" data-module="govuk-radios">
                  <div class="govuk-radios__item">
                    <input formControlName="copyData" (change)="updateRadio(customerDetailsForm, 'copyData', 'Yes')"
                      class="govuk-radios__input" id="Yes" name="copyData" type="radio" value="Yes" />
                    <label class=" govuk-radios__label" for="Yes">
                      Yes
                    </label>
                  </div>
                  <div class="govuk-radios__item">
                    <input formControlName="copyData" (change)="updateRadio(customerDetailsForm, 'copyData', 'No')"
                      class="govuk-radios__input" id="No" name="copyData" type="radio" value="No" />
                    <label class=" govuk-radios__label" for="No">
                      No
                    </label>
                  </div>
                </div>
              </div> -->

              <!-- Customer questions -->
              <div *ngFor="let question of customerQuestions">
                <!-- questions that arent required -->
                <ng-container *ngIf="!question.required">
                  <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'text_field'">
                    <h3>
                      <label for="{{ question.reference }}">
                        {{ question.name | translate }}
                      </label>
                    </h3>
                    <input formControlName="{{ question.reference }}" class="govuk-input" id="{{ question.reference }}"
                      name="{{ question.reference }}" type="text" />
                  </div>

                  <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'text_area'">
                    <h3>
                      <label class=" --l" for="more-detail">
                        Can you provide more detail?
                      </label>
                    </h3>
                    <div id="more-detail-hint" class="govuk-hint">
                      Do not include personal or financial information, like your
                      National Insurance number or credit card details
                    </div>
                    <textarea [attr.aria-required]="question.required ? 'true' : null" class="govuk-textarea"
                      id="more-detail" name="moreDetail" rows="5" aria-describedby="more-detail-hint"></textarea>
                  </div>

                  <h3>
                    <label for="{{ question.reference }}">
                      {{ question.name | translate }}
                    </label>
                  </h3>

                  <input [attr.aria-required]="question.required ? 'true' : null"
                    formControlName="{{ question.reference }}" class="govuk-input" id="{{ question.reference }}"
                    name="{{ question.reference }}" type="text" />

                  <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'number'">
                    <h3>
                      <label tabindex="0" for="{{ question.reference }}">
                        <!-- <span *ngIf="question.required"
                          aria-hidden="true" class="form-field-required-marker">
                          *</span> -->
                        {{ question.name | translateSplit }}</label>
                    </h3>

                    <input type="search" class="form-control" formControlName="{{ question.reference }}"
                      attr.aria-label="{{ question.name }} input field" (keypress)="keyPressNumberField($event)"
                      maxlength="11" />
                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                      <div *ngIf="form[question.reference].errors.required" role="alert">
                        {{
                        'COMMON.IS_REQUIRED'
                        | translate : { value: question.name | translateSplit }
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="govuk-form-group" *ngIf="
                      (question.visible && question.detail_type === 'select') ||
                      (question.visible && question.detail_type === 'select-price')
                    ">
                    <h3>
                      <label tabindex="0" for="{{ question.reference }}">
                        {{ question.name | translateSplit }}</label>
                    </h3>

                    <ng-select [searchable]="false" [clearable]="false" appearance="outline"
                      id="{{ question.reference }}" formControlName="{{ question.reference }}" bindLabel="name"
                      bindValue="name" [items]="question.options" (change)="onQuestionChange()"
                      [attr.aria-required]="question.required ? 'true' : null">
                    </ng-select>

                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                      <div *ngIf="form[question.reference].errors.required" role="alert">
                        {{
                        'COMMON.IS_REQUIRED'
                        | translate : { value: question.name | translateSplit }
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="govuk-form-group" *ngIf="
                      question.visible &&
                      question.detail_type === 'date' &&
                      question.id != 1
                    ">
                    <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                        class="form-field-required-marker">
                        *</span>
                      {{ question.name | translateSplit }}</label>
                    <input [attr.aria-required]="question.required ? 'true' : null" matInput
                      formControlName="{{ question.reference }}" [matDatepicker]="picker" readonly />
                    <mat-datepicker-toggle matSuffix [for]="picker">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker> </mat-datepicker>
                    <span *ngIf="question.help_text" class="help-text" tabindex="0"
                      [innerHTML]="question.help_text | translateSplit | noSanitise">
                    </span>
                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                      <div *ngIf="form[question.reference].errors.required" role="alert">
                        {{
                        'COMMON.IS_REQUIRED'
                        | translate : { value: question.name | translateSplit }
                        }}
                      </div>
                      <div *ngIf="form[question.reference].errors.pattern" role="alert">
                        {{ 'COMMON.AGE_VALIDATION' | translate }}
                      </div>
                    </div>
                  </div>

                  <!-- checkbox -->
                  <div class="govuk-form-group" *ngIf="
                      (question.visible && question.detail_type === 'check') ||
                      (question.visible && question.detail_type === 'check-price')
                    ">
                    <mat-checkbox formControlName="{{ question.reference }}" class="">
                      <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                          class="form-field-required-marker">
                          *</span></label>
                      <span *ngIf="question.price == 0">{{ question.name }}</span>

                      <span tabindex="-1" *ngIf="question.price > 0">{{ question.name }} -
                        {{ question.price / 100 | currency : 'GBP' : true }}</span>
                    </mat-checkbox>

                    <span *ngIf="question.help_text" class="help-text" tabindex="0"
                      innerHTML="question.help_text | translateSplit | noSanitise">
                    </span>

                    <div *ngIf="submitted && form[question.reference].errors?.required" role="alert" tabindex="0"
                      class="invalid-feedback">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                    <div *ngIf="submitted && form[question.reference].errors?.pattern" role="alert">
                      {{ question?.validation_message }}
                    </div>
                  </div>
                </ng-container>

                <!-- questions that are required -->
                <ng-container *ngIf="question.required">
                  <div class="govuk-form-group" [ngClass]="{
                      'govuk-form-group--error':
                        form[question.reference].errors?.required === true &&
                        submitted
                    }" *ngIf="question.visible && question.detail_type === 'text_field'">
                    <h3>
                      <label for="{{ question.reference }}">
                        <!-- <span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                          *</span> -->
                        {{ question.name | translate }}
                      </label>
                    </h3>
                    <p *ngIf="submitted && form[question.reference].errors?.errors" id="event-name-error"
                      class="govuk-error-message">
                      <span class="govuk-visually-hidden">Error:</span>
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translate }
                      }}
                    </p>
                    <input formControlName="{{ question.reference }}" class="govuk-input" id="{{ question.reference }}"
                      name="{{ question.reference }}" type="text" [ngClass]="{
                        'govuk-input--error':
                          form[question.reference].errors?.required === true &&
                          submitted
                      }" />
                  </div>

                  <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'text_area'">
                    <h3>
                      <label class=" --l" for="more-detail">
                        Can you provide more detail?
                      </label>
                    </h3>
                    <div id="more-detail-hint" class="govuk-hint">
                      Do not include personal or financial information, like your
                      National Insurance number or credit card details
                    </div>
                    <textarea [attr.aria-required]="question.required ? 'true' : null" class="govuk-textarea"
                      id="more-detail" name="moreDetail" rows="5" aria-describedby="more-detail-hint"></textarea>
                  </div>

                  <h3>
                    <label for="{{ question.reference }}">
                      <!-- <span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                        *</span> -->
                      {{ question.name | translate }}
                    </label>
                  </h3>

                  <input formControlName="{{ question.reference }}" class="govuk-input" id="{{ question.reference }}"
                    name="{{ question.reference }}" type="text" />

                  <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'number'">
                    <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                        class="form-field-required-marker">
                        *</span>
                      {{ question.name | translateSplit }}</label>
                    <input type="search" class="form-control" formControlName="{{ question.reference }}"
                      attr.aria-label="{{ question.name }} input field" (keypress)="keyPressNumberField($event)"
                      maxlength="11" />
                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                      <div *ngIf="form[question.reference].errors.required" role="alert">
                        {{
                        'COMMON.IS_REQUIRED'
                        | translate : { value: question.name | translateSplit }
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="govuk-form-group" *ngIf="
                      (question.visible && question.detail_type === 'select') ||
                      (question.visible && question.detail_type === 'select-price')
                    ">
                    <h3>
                      <label tabindex="0" [for]="question.reference"><span *ngIf="question.required" aria-hidden="true"
                          class="form-field-required-marker">
                          *</span>
                        {{ question.name | translateSplit }}</label>
                    </h3>
                    <ng-select [attr.aria-required]="question.required ? 'true' : null" [searchable]="false"
                      [clearable]="false" appearance="outline" id="{{ question.reference }}"
                      formControlName="{{ question.reference }}" bindLabel="name" bindValue="name"
                      [items]="question.options" (change)="onQuestionChange()">
                    </ng-select>

                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                      <div *ngIf="form[question.reference].errors.required" role="alert">
                        {{
                        'COMMON.IS_REQUIRED'
                        | translate : { value: question.name | translateSplit }
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="govuk-form-group" *ngIf="
                      question.visible &&
                      question.detail_type === 'date' &&
                      question.id != 1
                    ">
                    <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                        class="form-field-required-marker">
                        *</span>
                      {{ question.name | translateSplit }}</label>
                    <input [attr.aria-required]="question.required ? 'true' : null" matInput
                      formControlName="{{ question.reference }}" [matDatepicker]="picker" readonly />
                    <mat-datepicker-toggle matSuffix [for]="picker">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker> </mat-datepicker>
                    <span *ngIf="question.help_text" class="help-text" tabindex="0"
                      [innerHTML]="question.help_text | translateSplit | noSanitise">
                    </span>
                    <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                      <div *ngIf="form[question.reference].errors.required" role="alert">
                        {{
                        'COMMON.IS_REQUIRED'
                        | translate : { value: question.name | translateSplit }
                        }}
                      </div>
                      <div *ngIf="form[question.reference].errors.pattern" role="alert">
                        {{ 'COMMON.AGE_VALIDATION' | translate }}
                      </div>
                    </div>
                  </div>

                  <!-- checkbox -->
                  <div class="govuk-form-group" *ngIf="
                      (question.visible && question.detail_type === 'check') ||
                      (question.visible && question.detail_type === 'check-price')
                    ">
                    <mat-checkbox formControlName="{{ question.reference }}" class="">
                      <label tabindex="0"><span *ngIf="question.required" aria-hidden="true"
                          class="form-field-required-marker">
                          *</span></label>
                      <span *ngIf="question.price == 0">{{ question.name }}</span>

                      <span tabindex="-1" *ngIf="question.price > 0">{{ question.name }} -
                        {{ question.price / 100 | currency : 'GBP' : true }}</span>
                    </mat-checkbox>

                    <span *ngIf="question.help_text" class="help-text" tabindex="0"
                      innerHTML="question.help_text | translateSplit | noSanitise">
                    </span>

                    <div *ngIf="submitted && form[question.reference].errors?.required" role="alert" tabindex="0"
                      class="invalid-feedback">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                    <div *ngIf="submitted && form[question.reference].errors?.pattern" role="alert">
                      {{ question?.validation_message }}
                    </div>
                  </div>
                </ng-container>
              </div>
              <br />
            </form>
          </ng-container>

          <div id="form-builder">
            <ng-container *ngIf="showFormBuilder">
              <lib-form-builder [appConfig]="appConfig" [formId]="selectedFormId" [formData]="formData"
                [showSubmit]="false" [companyId]="appConfig.company_id" maxCertificates="1" (formReady)="formReady($event)"
                (formStatus)="updateAnswers($event)" (formSubmit)="selectService()" (schema)="storeSchema($event)"
                (companySet)="onCompanySet($event)" (serviceSet)="onServiceSet($event)"
                (resourceSet)="onResourceSet($event)" (staffSet)="onStaffSet($event)"
                (addDuration)="onAddDuration($event)" (addressSet)="onAddressSet($event)"
                (updateDatastore)="commonFunctions.updateDatastore($event)" (extraItemSet)="onExtraItemSet($event)"
                (extraItemChanged)="onExtraItemChanged($event)"
                (processing)="onFormProcessing($event)">
              </lib-form-builder>
            </ng-container>
          </div>

          <ng-container>

            @if(noticeGuidance?.length > 0) {
            <div [innerHTML]="noticeGuidance"></div>
            }

            <!-- <div class="govuk-grid-column-full"> -->
            <div>
              <app-booking-summary></app-booking-summary>
            </div>
          </ng-container>

          <app-fees-and-make-it-yours-enhancements *ngIf="selectedDepartment"
            [company]="selectedDepartment" [costBreakDown]="costBreakDown" [questions]="enhancedCostBreakdownQuestions"
            [outerFormSubmitted]="submitted" [adminJourney]="adminJourney"
            (questionChange)="addExtraBookingItemFee($event)"></app-fees-and-make-it-yours-enhancements>
        </div>


        @if(continueGuidance?.length > 0) {
        <div class="govuk-grid-column-full" [innerHTML]="continueGuidance" *ngIf="!adminJourney"></div>
        }

        <div class="govuk-grid-column-full">
          <button type="submit" class="btn btn-primary" (click)="onSubmit()" *ngIf="adminJourney">
            {{ 'FORM.CONTINUE' | translate }}
          </button>

          <button type="submit" class="btn btn-primary" (click)="onSubmit()" *ngIf="!adminJourney">
            {{ 'FORM.CONTINUE_MY' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
